import { useSearchParams } from 'react-router-dom';
import { AnimeGrid } from '@/components/anime/AnimeGrid';
import { Pagination } from '@/components/ui/Pagination';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { StateMessage } from '@/components/ui/StateMessage';
import { useAnimeSearch } from '@/hooks/useAnimeQueries';

export function SearchPage() {
	const [searchParams, setSearchParams] = useSearchParams();
	const keyword = (searchParams.get('q') ?? '').trim();
	const page = Math.max(1, Number(searchParams.get('page')) || 1);

	const searchQuery = useAnimeSearch(keyword, page);

	if (!keyword) {
		return (
			<section className="mt-6">
				<SectionHeader title="Tìm kiếm anime" />
				<StateMessage
					icon="⌕"
					title="Nhập tên anime bạn muốn tìm"
					description="Gõ vào ô tìm kiếm phía trên — chỉ hiện phim type hoạt hình, không lẫn live-action."
				/>
			</section>
		);
	}

	return (
		<section className="mt-6">
			<SectionHeader
				title={`Kết quả cho “${keyword}”`}
				action={
					searchQuery.data && (
						<span className="text-[13px] text-muted">
							{searchQuery.data.pagination.totalItems.toLocaleString('vi-VN')}
							{searchQuery.data.resultCapped ? '+' : ''} kết quả anime
						</span>
					)
				}
			/>

			<AnimeGrid
				items={searchQuery.data?.items ?? []}
				isLoading={searchQuery.isPending}
				isRefreshing={searchQuery.isFetching && !searchQuery.isPending}
				error={searchQuery.error}
				onRetry={() => void searchQuery.refetch()}
				emptyTitle={`Không tìm thấy anime nào cho “${keyword}”`}
				emptyDescription="Thử từ khoá ngắn hơn, hoặc tên gốc tiếng Nhật/tiếng Anh."
			/>

			{searchQuery.data && (
				<Pagination
					pagination={searchQuery.data.pagination}
					disabled={searchQuery.isFetching}
					onPageChange={(nextPage) => {
						const next = new URLSearchParams(searchParams);
						next.set('page', String(nextPage));
						setSearchParams(next);
					}}
				/>
			)}
		</section>
	);
}
